import {
    FaHotel,
    FaUtensils,
    FaCoffee,
    FaShoppingBag,
    FaShoppingCart,
    FaVolleyballBall,
    FaUmbrellaBeach,
    FaTree,
    FaLandmark,
    FaBicycle,
    FaBus,
    FaTaxi,
    FaTram,
    FaSubway,
    FaTrain,
    FaPlane,
    FaParking,
    FaCarSide,
    FaGasPump,
    FaWifi,
    FaQuestion,
} from "react-icons/fa";

export const LocationFacilities = [
    "HOTEL",
    "RESTAURANT",
    "CAFE",
    "MALL",
    "SUPERMARKET",
    "SPORT",
    "RECREATION_AREA",
    "NATURE",
    "MUSEUM",
    "BIKE_SHARING",
    "BUS_STOP",
    "TAXI_STAND",
    "TRAM_STOP",
    "METRO_STATION",
    "TRAIN_STATION",
    "AIRPORT",
    "PARKING_LOT",
    "CARPOOL_PARKING",
    "FUEL_STATION",
    "WIFI",
];


// Function to map facility string to object with id, text, and icon using switch case
export const GetFacilityDetails = (facilityName) => {
    switch (facilityName.toUpperCase()) {
        case "HOTEL":
            return { text: "Hotel", value: "HOTEL", icon: FaHotel };
        case "RESTAURANT":
            return { text: "Restaurant", value: "RESTAURANT", icon: FaUtensils };
        case "CAFE":
            return { text: "Cafe", value: "CAFE", icon: FaCoffee };
        case "MALL":
            return { text: "Mall", value: "MALL", icon: FaShoppingBag };
        case "SUPERMARKET":
            return { text: "Supermarket", value: "SUPERMARKET", icon: FaShoppingCart };
        case "SPORT":
            return { text: "Sport", value: "SPORT", icon: FaVolleyballBall };
        case "RECREATION_AREA":
            return { text: "Recreation Area", value: "RECREATION_AREA", icon: FaUmbrellaBeach };
        case "NATURE":
            return { text: "Nature", value: "NATURE", icon: FaTree };
        case "MUSEUM":
            return { text: "Museum", value: "MUSEUM", icon: FaLandmark };
        case "BIKE_SHARING":
            return { text: "Bike Sharing", value: "BIKE_SHARING", icon: FaBicycle };
        case "BUS_STOP":
            return { text: "Bus Stop", value: "BUS_STOP", icon: FaBus };
        case "TAXI_STAND":
            return { text: "Taxi Stand", value: "TAXI_STAND", icon: FaTaxi };
        case "TRAM_STOP":
            return { text: "Tram Stop", value: "TRAM_STOP", icon: FaTram };
        case "METRO_STATION":
            return { text: "Metro Station", value: "METRO_STATION", icon: FaSubway };
        case "TRAIN_STATION":
            return { text: "Train Station", value: "TRAIN_STATION", icon: FaTrain };
        case "AIRPORT":
            return { text: "Airport", value: "AIRPORT", icon: FaPlane };
        case "PARKING_LOT":
            return { text: "Parking Lot", value: "PARKING_LOT", icon: FaParking };
        case "CARPOOL_PARKING":
            return { text: "Carpool Parking", value: "CARPOOL_PARKING", icon: FaCarSide };
        case "FUEL_STATION":
            return { text: "Fuel Station", value: "FUEL_STATION", icon: FaGasPump };
        case "WIFI":
            return { text: "Wifi", value: "WIFI", icon: FaWifi };
        default:
            return { text: "Unknown", value: "UNKNOWN", icon: FaQuestion }; // Fallback (you can import FaQuestion from react-icons)
    }
};
